import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

export interface ReportType {
    downloadUrl: string; // 下载连接
    documentTypeId: string;
    description: string;
    id: string;
}

export type TradeConfirm = ReportType & {
    date: string; // 日期
};

class ReportInfo {
    statementList: ReportType[] | null = null;

    taxDocumentList: ReportType[] | null = null;

    getStatementList() {
        return Promise.resolve(
            this.statementList ||
                http
                    .get(API.TRADE.viewDoc.getStatements(), {
                        params: {
                            account_id: security.currentAccountId
                        }
                    })
                    .then(resp => (this.statementList = resp.data))
                    .catch(err => {
                        this.statementList = null;

                        throw err;
                    })
        );
    }

    getTaxDocumentList() {
        return Promise.resolve(
            this.taxDocumentList ||
                http
                    .get(API.TRADE.viewDoc.getTaxDocuments(), {
                        params: {
                            account_id: security.currentAccountId
                        }
                    })
                    .then(resp => (this.taxDocumentList = resp.data))
                    .catch(err => {
                        this.taxDocumentList = null;

                        throw err;
                    })
        );
    }

    getTradeConfirmList(fromDate, toDate) {
        return http
            .get(API.TRADE.viewDoc.getTradeConfirms(), {
                params: {
                    fromDate,
                    toDate,
                    account_id: security.currentAccountId
                }
            })
            .then(resp => resp.data);
    }
}

export default new ReportInfo();
